import { reactive } from "vue";

/**
 * getChainInfo の戻り値型
 */
export interface ChainInfo {
  customer_code: string;
  chain_code: string;
  name: string;
  max_unit?: number | null;
  cognito_user_pool_id?: string | null;
  cognito_user_client_id?: string | null;
  house_card_display?: number | null;
  house_card_validation?: string | null;
  operator_column_email: number;
  operator_column_tel: number;
  register_no_max_length: number;
  receipt_no_max_length: number;
  charter_admin_send_address?: string | null;
  is_hide_delivery_time_on_spot: number;
  is_hide_other_shop_members: number;
  is_delivery_address1_display: number;
  use_receipt_barcode_search_flg: number;
  idle_logout_seconds?: number | null;
  created_date: string;
  created_user_id: string;
  updated_date?: string | null;
  updated_user_id?: string | null;
}

/**
 * チェーン情報ストア
 * setupApp で取得した getChainInfo の結果をキャッシュし、
 * 子コンポーネントから即座に参照できるようにする。
 */
const state = reactive<{ chainInfo: ChainInfo | null }>({
  chainInfo: null,
});

export default {
  /** キャッシュ済みチェーン情報を取得 */
  get chainInfo(): ChainInfo | null {
    return state.chainInfo;
  },

  /** チェーン情報をストアに保存 */
  setChainInfo(info: ChainInfo | null | undefined): void {
    state.chainInfo = info ?? null;
  },

  /** ストアをクリア */
  clear(): void {
    state.chainInfo = null;
  },
};
